import React from "react";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";

const FOOTER_HEIGHT = 124;
const ICON_BG = "#1976d2"; // MUI blue[700]

const socialLinks = [
  {
    icon: <FacebookIcon sx={{ fontSize: 32 }} />,
    label: "Facebook",
    url: "https://www.facebook.com/lolapapacosta/",
  },
  {
    icon: <InstagramIcon sx={{ fontSize: 32 }} />,
    label: "Instagram",
    url: "https://www.instagram.com/lolapapacostatherapy/",
  },
];

const Footer: React.FC = () => (
  <Box
    component="footer"
    sx={{
      minHeight: FOOTER_HEIGHT,
      height: FOOTER_HEIGHT,
      background: "#29505c",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      mt: 4,
    }}
  >
    <Box sx={{ display: "flex", gap: 4 }}>
      {socialLinks.map((link) => (
        <Box
          key={link.label}
          sx={{ display: "flex", alignItems: "center", gap: 1 }}
        >
          <IconButton
            component="a"
            href={link.url}
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              background: ICON_BG,
              color: "#fff",
              borderRadius: 2,
              width: 56,
              height: 56,
              "&:hover": { background: "#1565c0" },
            }}
            aria-label={link.label}
          >
            {link.icon}
          </IconButton>
        </Box>
      ))}
    </Box>
  </Box>
);

export default Footer;
